import React from "react";
import AdaptiveImages from "../../atoms/image/AdaptiveImages";

type SecondFoldProps = {
  data: {
    desc: string[];
    platformBadge?: { image: HTMLImageElement & { url: string } }[];
    sortedPlatformBadge?: { image: HTMLImageElement & { url: string } }[];
    MobileSortedPlatformBadges?: {
      image: HTMLImageElement & { url: string };
    }[];
    image: {
      adaptive: { path: string };
    } & HTMLImageElement;
    heading: string;
  };
};

const SecondFold = ({ data }: SecondFoldProps) => {
  const Description = () => {
    const descCount = data.desc.length;
    return (
      <>
        {data.desc.map((item, count) => (
          <p
            key={count}
            className={
              descCount === 1
                ? "md:mb-5"
                : count === 0
                ? ""
                : "lg:mt-1.5 md:mt-1.5 md:mb-5"
            }
            dangerouslySetInnerHTML={{ __html: item }}
          />
        ))}
      </>
    );
  };

  const PlatformBadge = () => {
    return (
      <div className="mt-5 lg:d-fx">
        {data.platformBadge?.map((item, count, items) => (
          <img
            key={count}
            className={count === items.length - 1 ? "" : "mr-5"}
            loading="lazy"
            alt={item.image.alt}
            src={item.image.src}
          />
        ))}
      </div>
    );
  };

  const SortedPlatformBadge = ({ data, isMobile = false }) => {
    const userAgent =
      typeof navigator !== "undefined" ? navigator.userAgent : "";
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);

    const sortedData = data?.sort((a) => {
      if (isAndroid) return a.image.alt.includes("Android") ? -1 : 1;
      if (isIOS) return a.image.alt.includes("iOS") ? -1 : 1;
      return 0;
    });

    return (
      <div
        className={`mt-5 ${
          isMobile
            ? "md:d-fx fx--sa lg:d-none mx-auto text-center"
            : " lg:d-fx md:d-none"
        }`}
      >
        {sortedData?.map((item, count, items) => (
          <a href={item.image.url} key={count} style={{ fontSize: 0 }}>
            <img
              width={isMobile && 160}
              height={isMobile && "100%"}
              className={`${
                count === items.length - 1 ? "" : isMobile ? "mr-1" : "mr-5"
              }`}
              loading="lazy"
              alt={item.image.alt}
              src={item.image.src}
            />
          </a>
        ))}
      </div>
    );
  };

  return (
    <section className="bg-light lg:pt-10 lg:pb-20 md:pt-5 md:pb-10 highlight">
      <div className="grid--default has-align-top container md:fx md:fx--w">
        <picture className="lg:maxw-mds fx--o-2">
          <AdaptiveImages data={data.image.adaptive.path} />
          <img
            loading="lazy"
            src={`${data.image.adaptive.path}.png`}
            alt={data.image.alt}
            width="560"
            height="400"
            className="img-fit"
          />
        </picture>{" "}
        <article className="text-left md:mt-5 lg:maxw-md">
          <h2 className="text-lg lg:mb-3 md:mb-2 md:mr-3">{data.heading}</h2>
          <Description />
          {data.platformBadge ? <PlatformBadge /> : null}
          {data.sortedPlatformBadge && (
            <SortedPlatformBadge data={data.sortedPlatformBadge} />
          )}
          {data.MobileSortedPlatformBadges && (
            <SortedPlatformBadge
              data={data.MobileSortedPlatformBadges}
              isMobile={true}
            />
          )}
        </article>
      </div>
    </section>
  );
};

export default SecondFold;
